<template>
  <div class="vp-width-416 vp-ma-auto">
    <div class="d-flex align-items-center justify-content-end modal-title-head">
      <div class="title-head">
        <p class="feedback-title-head">
          {{ $t("journeyBuilder.feedbackSettings") }}
        </p>
      </div>
      <svg
        @click="$bvModal.hide('feedback-modal')"
        class="CloseFeedbackSettings"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <div
      class="text-areas-cont"
      v-for="setting in settings"
      :key="setting.name"
    >
      <template v-if="setting.name != 'display_name_feedback'">
        <vp-textarea
          v-model="$v.feedbackSetting[setting.name].value.$model"
          :label="setting.label"
          rows="1"
          width="416"
          height="124"
          class="form-input-spacing"
        ></vp-textarea>
      </template>
    </div>

    <hr class="line-separator" />

    <div class="vp-pb-8">
      <p class="username-header">{{ $t("journeyBuilder.showUserNameAs") }}</p>
      <v-radio-group
        v-model="$v.feedbackSetting.display_name_feedback.value.$model"
      >
        <v-radio
          :label="$t('common.firstName')"
          value="1"
          class="feedback-name-radio-option"
        ></v-radio>
        <v-radio
          :label="$t('common.lastName')"
          value="2"
          class="feedback-name-radio-option"
        ></v-radio>
        <v-radio
          :label="$t('journeyBuilder.both')"
          value="0"
          class="feedback-name-radio-option"
        ></v-radio>
      </v-radio-group>
    </div>

    <div class="d-flex justify-content-end vp-mt-32 submit-con">
      <button
        @click="submit"
        class="btn btn-primary save-feedback"
        :disabled="$v.feedbackSetting.$invalid || !$v.feedbackSetting.$anyDirty"
      >
        {{ $t("common.save") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    settings: {
      type: Array,
      default: () => [
        {
          name: "granted_message",
          label: this.$t("journeyBuilder.grantedMessage"),
          type: "string",
          value: "Welcome!",
        },
        {
          name: "denied_message",
          label: this.$t("journeyBuilder.deniedMessage"),
          type: "string",
          value: "Entry denied, Please seek assistance.",
        },
        {
          name: "good_bye_message",
          label: this.$t("journeyBuilder.goodByeMessage"),
          type: "string",
          value: "Good Bye!",
        },
        {
          name: "display_name_feedback",
          label: `${this.$t("journeyBuilder.showUserNameAs")}:`,
          type: "int",
          value: "0",
        },
      ],
    },
  },
  data() {
    return {
      feedbackSetting: {
        granted_message: null,
        denied_message: null,
        good_bye_message: null,
        display_name_feedback: null,
      },
    };
  },
  validations: {
    feedbackSetting: {
      granted_message: {
        value: {
          required,
        },
      },
      denied_message: {
        value: {
          required,
        },
      },
      good_bye_message: {
        value: {
          required,
        },
      },
      display_name_feedback: {
        value: {
          required,
        },
      },
    },
  },
  beforeMount() {
    this.settings.forEach((setting) => {
      this.feedbackSetting[setting.name] = cloneDeep(setting);
    });
  },
  methods: {
    submit() {
      this.$emit("updateFeedback", {
        settings: this.feedbackSetting,
      });
      this.$bvModal.hide("feedback-modal");
    },
  },
};
</script>
<style lang="scss">
div#feedback-modal___BV_modal_content_ {
  .v-input--radio-group__input {
    flex-direction: column !important;
  }
  label.v-label.theme--light {
    padding-inline-start: 16px !important;
  }

  width: 500px !important;
  box-shadow: 0px 1px 40px 3px #0000000d !important;
  border-radius: 26px !important;
  div#feedback-modal___BV_modal_body_ {
    padding: 40px 0px 40px !important;
    // padding-bottom: 20px;
    border-radius: 26px;
    .md-field.md-theme-default label {
      padding-top: 12px !important;
    }
    .text-areas-cont {
      width: 416px;
      margin: auto;
    }
    .submit-con {
      width: 416px;
      margin-inline-end: auto;
      margin-inline-start: auto;
    }
    .md-textarea {
      font-size: 16px !important;
      font-weight: 700 !important;
    }
    button.btn.btn-primary.save-feedback {
      width: 416px !important;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: 700;
      line-height: 17px;
      &:disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }
    }
    p.feedback-title-head {
      font-size: 16px;
      font-weight: 700;
      line-height: 20.4px;
      color: #000000;
      margin-bottom: 0px !important;
      margin-inline-end: 124px;
    }
    .CloseFeedbackSettings {
      margin-inline-end: -3px;
      margin-top: -5px;
    }
    .d-flex.align-items-center.justify-content-end.modal-title-head {
      margin-bottom: 40px;
      margin-inline-end: auto;
      width: 416px;
      margin-inline-start: auto;
    }
    .line-separator {
      width: 416px;
      margin: 24px auto;
      color: #ebebeb;
    }
    .form-input-spacing {
      margin-bottom: 16px;
    }
    .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
      margin-bottom: 3px;
    }

    .username-header {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      letter-spacing: 0.25px;
      text-align: start;
      color: #787878;
      margin-bottom: 28px;
    }
  }
}
</style>
